import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from '../../../services/session.service';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorService } from '../../../services/proveedor.service';
import { ActividadEconomicaService } from '../../../services/actividad-economica.service';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';
import { ValidarCorreoService } from '../../../services/validar-correo.service';


@Component({
	selector: 'app-proveedor-edit',
	templateUrl: './proveedor-edit.component.html',
	styleUrls: ['./proveedor-edit.component.css'],
	providers: [
		ProveedorService, 
		ActividadEconomicaService,
		SessionService,
		ValidarCorreoService
	]
})

export class ProveedorEditComponent implements OnInit {
	@ViewChild('identificacionFocus') identificacionElement: ElementRef;
	public proveedor: Proveedor;
	public msg: SweetMessage;
	public actividades = [];
	public vl: Validation;
	public loading = false;
	public correos: Array<any>;
	public correo_invalid:Boolean;
	constructor(
		private proveedorService: ProveedorService,
		private actividad: ActividadEconomicaService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
		public correoService:ValidarCorreoService,
	) {	
		this.msg = new SweetMessage();
		this.vl = new Validation();
		this.proveedor = new Proveedor();
		this.correos = [];
		this.proveedor.tipo_identificacion_id = 1;
		this.storage.getItem("proveedor").subscribe(data => {
			this.proveedor = data;
			
			if( this.proveedor.correo.trim().length ){
				this.correos = this.proveedor.correo.split(',');
			}
		});
		this.correo_invalid = false;
	}

	ngOnInit() {
		this.getActividades();
	}

	onSubmit() {
		this.setValueEntity();
		this.loading = true;
		this.proveedorService.update(this.proveedor).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', err);
			}
		);
	}

	getActividades() {
		this.loading = true;
		this.actividad.getAll().subscribe(
			res => {
				this.loading = false;
				if (!res.length) {
					this.actividades = [];
				} else {
					this.actividades = res;
				}
			},
			err => {
				this.loading = false;
				this.actividades = [];
			}
		);
	}
	
	setValueEntity(){
		this.proveedor.empresa_id = this.ss.getData("empresa_id");
		this.proveedor.usuario_id = this.ss.getData("usuario_id");
		this.proveedor.razon_social = this.proveedor.razon_social.trim();
		this.proveedor.nombre_comercial = this.proveedor.nombre_comercial.trim();
		this.proveedor.correo = this.correos.toString();
		switch (this.proveedor.tipo_identificacion_id){
			case 1: 
				this.proveedor.tipo_dni = "RUC";
				break;
			case 2: 
				this.proveedor.tipo_dni = "CED";
				break;
			case 3:
				this.proveedor.tipo_dni = "PAS";
				break;
		}
	}

	isValidForm(){
		if(!this.proveedor.razon_social){
			return false
		}
		if(!this.proveedor.nombre_comercial){
			return false
		}
		if(!this.proveedor.dni){
			return false
		}
		if(!this.proveedor.telefono){
			return false
		}
		if(!this.proveedor.direccion){
			return false
		}
		if(!this.proveedor.tipo_persona){
			return false
		}
		if(!this.proveedor.tipo_identificacion_id){
			return false
		}
		/*if(this.proveedor.es_contribuyente){
			if(!this.proveedor.num_contribuyente){
				return false;
			}
		}*/
		if(this.proveedor.dni){
			if(this.proveedor.tipo_identificacion_id == 1){
				if( this.proveedor.dni.length < 13 ){
					return false;
				}else if( isNaN(this.proveedor.dni.toString() as any) ){
					return false;
				}
			}
			if(this.proveedor.tipo_identificacion_id == 2){
				if( this.proveedor.dni.length < 10 ){
					return false;
				}else if( isNaN(this.proveedor.dni.toString() as any) ){
					return false;
				}
			}
			if(this.proveedor.tipo_identificacion_id == 3 && this.proveedor.dni.length < 4){
				return false;
			}
		}

		if(this.proveedor.telefono && this.proveedor.telefono.length < 4){
			return false;
		}

		if(this.proveedor.celular && this.proveedor.celular.length < 4){
			return false;
		}
		/*if( !this.correos.length ){
			return false;
		}*/
		if (this.correo_invalid) {
			return false;
		}


		return true;
	}

	onChangeIdentificacion(id){
		this.proveedor.tipo_identificacion_id = id;
		this.msg.showMessage('error-message',"Ingrese número de identificación")
		this.proveedor.dni = "";
		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);

	}

	onChangeTipoPersona(){
		if(this.proveedor.tipo_persona == 'N'){
			this.proveedor.nombre_comercial = '';
		}

		setTimeout(()=>{ 
			this.identificacionElement.nativeElement.focus();
		},0);
	}

	validarCorreo() {
		if (this.correos.length > 0) {
			let count_true = 0;
			let count_false = 0;
			for (let index = 0; index < this.correos.length; index++) {
				let res = this.correoService.isEmailValido(this.correos[index]);
				if (res) {
					count_true++;

				} else {
					count_false++;
				}

			}
			if (count_false > 0) {
				this.correo_invalid = true;
			} else {
				this.correo_invalid = false;
			}


		} else {
			this.correo_invalid = false;
		}
	}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/proveedor-edit/proveedor-edit.component.ts